import React from "react";
import { useSelector } from "react-redux";
import { getAppColor } from "@icarius-app/selectors";
import { ImagePlaceholder } from "@icarius-icons/index";
import MediaPlayer from "@icarius-common/mediaPlayer";

const Thumbnail = ({ path, isVideo }) => {
    const color = useSelector(getAppColor);

    return (
        <div
            style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                aspectRatio: "16/9",
                backgroundColor: color,
                overflow: "hidden",
            }}
        >
            {!path && <ImagePlaceholder fontSize="small" width={75} height={75} style={{ fill: "#fff" }} />}
            {path && !isVideo && (
                <img
                    style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                    }}
                    src={path}
                    alt={"error"}
                />
            )}
            {path && isVideo && <MediaPlayer url={path} />}
        </div>
    );
};

export default Thumbnail;
